module.exports = __webpack_public_path__ + "static/img/M-5.b7c3fb1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mzhongfu/M-5.png
// module id = v0ar
// module chunks = 0